import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UnsubscribePageRoutingModule } from './unsubscribe-routing.module';
import { UnsubscribeComponent } from './unsubscribe.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, UnsubscribePageRoutingModule],
  declarations: [UnsubscribeComponent],
})
export class UnsubscribeModule {}
